
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'carret-up': {
    width: 10,
    height: 5,
    viewBox: '0 0 10 5',
    data: '<path pid="0" d="M10 5L5 0 0 5z"/>'
  }
})
